import React, {useContext, useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom';
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import axios from "axios";
import {UserContext} from "./UserContext";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {getBearerToken, getServerUrl} from "./utils/utils";

function Friends() {
    const history = useHistory()
    const {user} = useContext(UserContext)

    const [friends, setFriends] = useState([])
    const [searchedFriends, setSearchedFriends] = useState([])
    const [friendSuggestions, setFriendSuggestions] = useState([])
    const [category, setCategory] = useState('search')
    const [searchValue, setSearchValue] = useState('')

    const fetchFriends = async () => {
        axios.get(`${getServerUrl()}/friends`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setFriends(response.data)
            })
    }

    const fetchFriendSuggestions = async () => {
        axios.get(`${getServerUrl()}/friendSuggestions`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setFriendSuggestions(response.data)
            })
    }

    useEffect(() => {
        fetchFriends()
        fetchFriendSuggestions()
    }, [])

    const displayFriendsList = (userList, listType) => userList.map(user => {
        const friendActionsObject = {
            ACCEPTED: {
                label: "Friends",
                action: () => {}
            },
            PENDING: {
                label: "Pending",
                action: () => {}
            }
        }
        let userObj = user
        let userAction = null
        if (listType === 'friends') {
            userObj = user.friend
            userAction = <Button onClick={e => {
                e.stopPropagation()
                console.log("click two")}
            }>
                {user.status === "ACCEPTED" ? "FRIENDS" : "PENDING"}
            </Button>
        } else if (listType === 'search') {
            userObj = user.user
            const actionsObject = friendActionsObject[user.friendStatus] || {label: "Add Friend", action: () => addFriend(userObj.id)}
            userAction = <Button disabled={actionsObject?.label === "Pending"} onClick={actionsObject?.action}>{actionsObject?.label}</Button>
        } else {
            userObj = user.friendStatus ? user.user : user
            const actionsObject = friendActionsObject[user.friendStatus] || {label: "Add Friend", action: () => addFriend(userObj.id)}
            userAction = <Button disabled={actionsObject?.label === "Pending"} onClick={actionsObject?.action}>{actionsObject?.label}</Button>
        }
        const userIsFriend = user.status === 'ACCEPTED' || user.friendStatus === 'ACCEPTED'
            return (
        <Card sx={{ maxWidth: 345 }}>
            <CardHeader
                avatar={
                    <Avatar sx={{width: 75, height: 75}} src={userObj.profilePictureUrl}/>
                }
                action={
                    userAction
                }
                title={userObj.username}
                onClick={() => {
                    if (userIsFriend){
                        history.push(`/profile/${userObj.id}`)
                    }
                    console.log("click")
                }}
                className={userIsFriend ? "friend-card" : ""}
            />
        </Card>
            )})

    const searchForFriends = async () => {
        axios.get(`${getServerUrl()}/user/search/${searchValue}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setSearchedFriends(response.data)
            })
    }

    const addFriend = async userId => {
        axios.post(`${getServerUrl()}/friends`, {
            friendId: userId
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            }
        }).then(response => {
            if (category === 'search') {
                setSearchedFriends(searchedFriends.map(searchedFriend => {
                    if (searchedFriend.user.id === response.data.friend.id) {
                        return {user: searchedFriend.user, friendStatus: response.data.status}
                    }
                    return searchedFriend
                }))
                setFriendSuggestions(friendSuggestions.map(friendSuggestion => {
                    if (friendSuggestion.id === response.data.friend.id) {
                        return {user: friendSuggestion, friendStatus: response.data.status}
                    }
                    return friendSuggestion
                }))
            }
            setFriends([...friends, response.data])
        });
    }

    return (
        <div className="friends-container">
            <div className="profile-button-group-container">
                <ToggleButtonGroup
                    value={category}
                    exclusive
                    onChange={(event, selected) => setCategory(selected)}
                    aria-label="text alignment"
                >
                    <ToggleButton value='search' aria-label="left aligned">
                        Search
                        </ToggleButton>
                    <ToggleButton value='friends' aria-label="left aligned">
                        Your Friends
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
            {category  === 'search' && (
                <div>
                <div className="ranking-modal-info-container">
                    <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        options={[]}
                        renderInput={(params) => <TextField {...params}
                                                            label="Search for your friends..."/>}
                        onInputChange={(event, newInputValue) => {
                            setSearchValue(newInputValue)
                        }}
                        inputValue={searchValue}
                    />
                    <Button variant="contained" onClick={() => searchForFriends()}>Search</Button>
                </div>
                    {(searchedFriends?.length <= 0 && friendSuggestions?.length > 0) && (
                        <h3>People you may know</h3>
                    )}
                    {searchedFriends?.length > 0 ? displayFriendsList(searchedFriends, "search") : displayFriendsList(friendSuggestions, null)}
                </div>
            )}
            {category === 'friends' && (
                <div className="friends-list">
                    {displayFriendsList(friends, "friends")}
                </div>
            )}

        </div>
    )
}

export default Friends;